module.exports = __webpack_public_path__ + "img/machete.6d5fd421.png";